import { Post } from '../helpers';

type CheckProjectNameRequest = {
  channel: number;
  projectName: string;
  eventId: number | null;
};

export const ValidateProjectName = ({
  channel,
  projectName,
  eventId,
}: CheckProjectNameRequest): Promise<{ exists: boolean }> => {
  // Potential TODO: could use redux to dispatch an async action and "cache" the name check for faster response
  return Post({
    path: '/v3/admin/events/check-event-name',
    body: { eventName: projectName, event: eventId, channel },
  });
};
